import { IconPlus, IconX } from '@tabler/icons-react';
import _debounce from 'lodash/debounce';
import React, { useEffect, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { toast } from 'sonner';
import { getApi, postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import IconButton from '../../../components/Buttons/IconButton';

const CreatePromotionModal = ({ buttonComponent, callback }) => {

    const [show, setShow] = useState(false);
    const [showAddInfluencerDetails, setShowAddInfluencerDetails] = useState(false);
    const [showAddAgentDetails, setShowAddAgentDetails] = useState(false);
    const [loadingState, setLoadingState] = useState({
        loadingAgent: false,
        loadingInfluencer: false,
        loadingDestinationUrlCheck: false
    });
    const [agentList, setAgentList] = useState(null);
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [influencerList, setInfluencerList] = useState(null);
    const [selectedInfluencer, setSelectedInfluencer] = useState(null);
    const [customBackResp, setCustomBackResp] = useState(null);
    const [destinationUrlCheck, setDestinationUrlCheck] = useState(null);
    const [agentSearchValue, setAgentSearchValue] = useState(null);
    const [influencerSearchValue, setInfluencerSearchValue] = useState(null);
    const [agentInfluencerLinkStatus, setAgentInfluencerLinkStatus] = useState(null);
    const [showDeepLinkSection, setShowDeepLinkSection] = useState(false);
    const [deepLinkData, setDeepLinkData] = useState([{ key: null, value: null }]);
    const [preDefineLinks, setPreDefineLinks] = useState([])

    const handleClose = () => {
        setCustomBackResp(null);
        setShowAddInfluencerDetails(false);
        setShowAddAgentDetails(false);
        setAgentList(null);
        setSelectedAgent(null);
        setSelectedInfluencer(null);
        setInfluencerList(null);
        setAgentSearchValue(null);
        setInfluencerSearchValue(null);
        setAgentInfluencerLinkStatus(null);
        setDestinationUrlCheck(null);
        setShowDeepLinkSection(false);
        setDeepLinkData([{ key: null, value: null }]);
        setShow(false)
    };

    const handleShow = () => getList();

    async function getList() {
        loadingShow();
        let resp = await getApi(urlApi.getPredefinedPromotionUrlList);
        setShow(true)
        loadingHide();
        if (resp.responseCode === 200) {
            setPreDefineLinks(resp.data);
        } else {
            setPreDefineLinks([]);
        }
    }

    const searchAgent = async (e) => {
        if (e.target.value.length >= 3) {
            setLoadingState({ ...loadingState, loadingAgent: true });
            let resp = await getApi(`${urlApi.searchAgent}?search=${e.target.value}`);
            setLoadingState({ ...loadingState, loadingAgent: false });
            if (resp?.responseCode === 200) {
                setAgentList(resp);
            } else {
                setAgentList(resp);
            }
        } else {
            toast.warning("Type minimum of 3 letters!");
            setAgentList(null);
        }
    }

    useEffect(() => {
        if (agentSearchValue) {
            searchAgent(agentSearchValue);
        }
        return () => {

        };
    }, [agentSearchValue]);

    function onAgentSelect(agentData) {
        setSelectedAgent(agentData);
        setAgentList(null)
        document.getElementById('agentSearch').value = agentData.name;
    }

    const searchInfluencer = async (e) => {
        if (e.target.value.length >= 3) {
            setLoadingState({ ...loadingState, loadingInfluencer: true });
            let resp = await getApi(`${urlApi.searchInfluencer}?search=${e.target.value}`);
            setLoadingState({ ...loadingState, loadingInfluencer: false });
            if (resp.responseCode === 200) {
                setInfluencerList(resp);
            } else {
                setInfluencerList(resp);
            }
        } else {
            toast.warning("Type minimum of 3 letters!");
            setInfluencerList(null);
        }
    }

    useEffect(() => {
        if (influencerSearchValue) {
            searchInfluencer(influencerSearchValue);
        }
        return () => {

        };
    }, [influencerSearchValue]);

    function onInfluencerSelect(influencerData) {
        setSelectedInfluencer(influencerData);
        setInfluencerList(null)
        document.getElementById('influencerSearch').value = influencerData.channelName;
    }

    const checkCustomBackHalf = async (e) => {
        let postData = {
            "linkCode": e.target.value?.trim(),
        }
        if (e.target.value?.length >= 3) {
            let resp = await postApi(postData, urlApi.checkCustomBackHalfForPromotion);
            setCustomBackResp(resp);
        } else if (e.target.value?.length == 0) {
            setCustomBackResp(null);
        }
    }

    const checkPromotionDestinationLink = async (e) => {
        setLoadingState({ ...loadingState, loadingDestinationUrlCheck: true });
        let postData = {
            "destinationUrl": e.target.value?.trim(),
        }
        if (e.target.value?.length >= 3) {
            let resp = await postApi(postData, urlApi.checkPromotionDestinationLink);
            setLoadingState({ ...loadingState, loadingDestinationUrlCheck: false });
            setDestinationUrlCheck(resp);
        } else if (e.target.value?.length == 0) {
            setDestinationUrlCheck(null);
        }
    }

    const addAgent = async () => {
        let agentPostData = {
            name: document.getElementById("agentName")?.value?.trim(),
            phone: document.getElementById("agentMobile")?.value?.trim(),
        }
        let agentResp = await postApi(agentPostData, urlApi.addAgent);
        if (agentResp?.responseCode === 200) {
            setSelectedAgent(agentResp?.data);
            return agentResp?.data?._id;
        } else {
            toast.error(agentResp?.message);
            return;
        }
    }

    const addInfluencer = async () => {
        let influencerPostData = {
            channelName: document.getElementById("channelName")?.value?.trim(),
            channelLink: document.getElementById("channelLink")?.value?.trim(),
        }
        let influencerResp = await postApi(influencerPostData, urlApi.addInfluencer);
        if (influencerResp?.responseCode === 200) {
            setSelectedInfluencer(influencerResp?.data);
            return influencerResp?.data?._id;
        } else {
            toast.error(influencerResp?.message);
            return;
        }
    }

    const checkAgentInfluencerLinkStatus = async () => {
        let resp = await getApi(urlApi.checkAgentInfluencerLinkStatus + selectedAgent?._id + "/" + selectedInfluencer?._id);
        setAgentInfluencerLinkStatus(resp);
    }

    useEffect(() => {
        if (selectedAgent?._id && selectedInfluencer?._id) {
            checkAgentInfluencerLinkStatus();
        }
        return () => {
            setAgentInfluencerLinkStatus(null);
        }
    }, [selectedAgent, selectedInfluencer]);

    const createPromotion = async () => {
        loadingShow();
        let postData = {};
        let localData = {
            link: document.getElementById("destinationUrl")?.value?.trim(),
            influencerId: selectedInfluencer?._id ? selectedInfluencer?._id : showAddInfluencerDetails ? await addInfluencer() : null,
            amount: document.getElementById("amount")?.value?.trim(),
            name: document.getElementById("promotionName")?.value?.trim(),
            linkCode: document.getElementById("custom-back-half")?.value?.trim(),
            description: document.getElementById("description")?.value?.trim(),
            agentId: selectedAgent?._id ? selectedAgent?._id : showAddAgentDetails ? await addAgent() : null,
            adMedium: document.getElementById("adMedium")?.value,
            creativeType: document.getElementById("adCreativeType")?.value,
            deepLinkData: showDeepLinkSection
        }
        postData = {
            link: localData.link,
            influencerId: localData.influencerId,
            amount: localData.amount,
        }

        if (!postData?.link) {
            toast.error("Destination URL is required.");
            loadingHide();
            return;
        }

        if (!postData?.amount) {
            toast.error("Amount is required.");
            loadingHide();
            return;
        }

        if (!postData?.influencerId) {
            toast.error("Please Select an Influencer.");
            loadingHide();
            return;
        }

        if ((document.getElementById("agentName")?.value || document.getElementById("agentMobile")?.value) && !localData?.agentId) {
            toast.error("Please Select an Agent or Add a New Agent. or remove agent details.");
            loadingHide();
            return;
        }

        if (localData?.deepLinkData) {
            const isAllKeyHaveData = deepLinkData?.every((item) => {
                return item.key && item.value;
            });
            if (!isAllKeyHaveData) {
                toast.error("Deep Link Data must have both Key and Value.");
                loadingHide();
                return;
            }

            const convertedToObject = deepLinkData?.reduce((acc, item) => {
                acc[item.key] = item.value;
                return acc;
            }, {});

            postData.deepLinkData = convertedToObject;
        }

        if (localData?.description) {
            postData.description = localData.description;
        }

        if (localData?.name) {
            postData.name = localData.name;
        }
        if (localData?.linkCode) {
            postData.linkCode = localData.linkCode;
        }
        if (localData?.agentId || document.getElementById("agentName")?.value || document.getElementById("agentMobile")?.value) {
            postData.agentId = localData.agentId;
        }
        if (localData?.adMedium) {
            postData.adMedium = localData.adMedium;
        }
        if (localData?.creativeType) {
            postData.creativeType = localData.creativeType;
        }
        let resp = await postApi(postData, urlApi.createPromotion);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            callback?.();
            handleClose();
        } else {
            toast.error(resp.message);
        }
    }

    const adCreativeTypes = {
        1: "Image",
        2: "Video",
        3: "Carousel",
        4: "GIF",
        5: "Text",
        6: "HTML5 Banner",
        7: "Interactive",
        8: "Audio",
        9: "Others"
    };

    const adMediums = {
        1: "Meta Ads",
        2: "Google Ads",
        3: "YouTube Ads",
        4: "Twitter (X) Ads",
        5: "Email",
        6: "SMS",
        7: "WhatsApp",
        8: "Others"
    };

    const updateDeepLinkData = (value, index, type) => {
        let updatedData = [...deepLinkData];
        updatedData[index][type] = value;
        setDeepLinkData(updatedData);
    }

    const removeDeepLinkData = (index) => {
        let updatedData = [...deepLinkData];
        updatedData.splice(index, 1);
        setDeepLinkData(updatedData);
    }

    const addDeepLinkField = () => {
        setDeepLinkData([...deepLinkData, { key: '', value: '' }]);
    }

    return (
        <>
            <div className='max-w-max' onClick={handleShow} >{buttonComponent}</div>

            <Modal show={show} onHide={handleClose} size='xl' backdrop="static">
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Create Promotion</p>
                        <IconX className={`${(loadingState?.loadingAgent || loadingState?.loadingInfluencer || loadingState?.loadingDestinationUrlCheck) ? 'cursor-not-allowed pointer-events-none' : 'cursor-pointer'}`} onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 !mb-10">
                        <div className="col-span-2">
                            <label htmlFor="promotionName" className='text-sm font-semibold mb-1'>Promotion Title</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='promotionName' />
                        </div>
                        <div className="col-span-2">
                            <label htmlFor="description" className='text-sm font-semibold mb-1'>Description</label>
                            <textarea type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='description' maxLength={255} ></textarea>
                        </div>
                        <div className="col-span-2 md:col-span-1">
                            <label htmlFor="adMedium" className='text-sm font-semibold mb-1'>Medium</label>
                            <select className="w-full px-3 py-2 rounded-md border-2 text-sm" id='adMedium'>
                                <option value="">--Select--</option>
                                {Object.entries(adMediums).map(([key, value]) => (
                                    <option key={key} value={key}>{value}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-span-2 md:col-span-1">
                            <label htmlFor="adCreativeType" className='text-sm font-semibold mb-1'>Creative Type</label>
                            <select className="w-full px-3 py-2 rounded-md border-2 text-sm" id='adCreativeType'>
                                <option value="">--Select--</option>
                                {Object.entries(adCreativeTypes).map(([key, value]) => (
                                    <option key={key} value={key}>{value}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-span-2">
                            <label htmlFor="destinationUrl" className='text-sm font-semibold mb-1'>Destination URL*</label>
                            <div className={`flex items-center rounded-md border-2 py-1.5 px-3 ${destinationUrlCheck && (destinationUrlCheck?.responseCode == 200 ? "border-green-700" : 'border-red-700')}`}>
                                <input type="text" className={`w-full py-1.5 text-sm focus:outline-none placeholder-[var(--secondary-text)]`} list='predefined-url' placeholder='' id='destinationUrl' onChange={_debounce((e) => checkPromotionDestinationLink(e), 500)} />
                                {loadingState?.loadingDestinationUrlCheck && <Spinner />}
                            </div>
                            {
                                destinationUrlCheck &&
                                <div className={`text-xs text-end mt-2 ps-1 ${destinationUrlCheck?.responseCode == 200 ? "text-green-700" : 'text-red-700'}`}>{destinationUrlCheck?.message}</div>
                            }
                        </div>

                        <datalist id="predefined-url">
                            {
                                preDefineLinks?.map((url) => {
                                    return (
                                        <option value={url.promotionUrl}></option>
                                    )
                                })
                            }
                        </datalist>

                        <div className="col-span-2">
                            <div className="flex justify-between items-center gap-2">
                                {showDeepLinkSection ? <label htmlFor="name" className='text-sm font-semibold mb-1'>DeepLink Details (Key & Value)</label> : <span>&nbsp;</span>}
                                <div className='flex items-center gap-2'>
                                    <label htmlFor='deepLinkSection' className="text-sm font-semibold">Add DeepLink Details</label>
                                    <input type="checkbox" className="h-4 w-4" id="deepLinkSection" onChange={(e) => {
                                        setShowDeepLinkSection(e.target.checked)
                                    }} />
                                </div>
                            </div>

                            {showDeepLinkSection && (
                                <div className='!mt-3'>
                                    {deepLinkData?.map((item, index) => {
                                        return (
                                            <div className='flex gap-2 items-center mb-2'>
                                                <input type='text' className='w-full px-3 py-2 rounded-md border-2 text-sm' placeholder='DeepLink Key' value={item.key} onChange={(e) => {
                                                    updateDeepLinkData(e.target.value, index, 'key')
                                                }} />
                                                <input type='text' className='w-full px-3 py-2 rounded-md border-2 text-sm' placeholder='DeepLink Value' value={item.value} onChange={(e) => {
                                                    updateDeepLinkData(e.target.value, index, 'value')
                                                }} />
                                                {deepLinkData?.length > 1 && <IconButton icon={<IconX size={18} className='cursor-pointer text-red-700' />} onClickFunction={() => removeDeepLinkData(index)} />}
                                            </div>
                                        )
                                    })}
                                    {deepLinkData?.length < 5 && <IconButton cssClass={'mx-auto !mt-3'} icon={<IconPlus size={18} />} text={"Add More"} onClickFunction={() => addDeepLinkField()} />}
                                </div>
                            )}
                        </div>

                        <div className="col-span-2 md:col-span-1">
                            <label htmlFor="amount" className='text-sm font-semibold mb-1'>Amount*</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='amount' />
                        </div>
                        <div className="col-span-2 md:col-span-1">
                            <div className='mb-3 w-full px-2'>
                                <label htmlFor="" className='text-sm font-semibold mb-1'>Custom back-half</label>
                                <input type='text' id='custom-back-half' className='w-full px-3 py-2 rounded-md border-2 text-sm' placeholder='Minimum 3 Character' onChange={_debounce((e) => checkCustomBackHalf(e), 300)} />
                                <p className="mb-0 text-xs text-gray-500">
                                    *Minimum 3 characters, including alphanumeric characters and special characters (only '-' , '_').
                                </p>
                                {
                                    customBackResp &&
                                    <div className={`text-xs ps-1 ${customBackResp?.responseCode == 200 ? "text-green-700" : 'text-red-700'}`}>{customBackResp?.message}</div>
                                }
                            </div>
                        </div>
                    </div>

                    {/* Influencer */}
                    <div className="mb-10">
                        <div className='flex gap-2 justify-between items-center mb-2 flex-wrap'>
                            <label htmlFor="name" className='text-sm font-semibold mb-1'>Select Influencer*</label>
                            <div className='flex items-center gap-2'>
                                <label htmlFor='addInfluencerDetailsCheckbox' className="text-sm font-semibold">Add New Influencer Details</label>
                                <input type="checkbox" className="h-4 w-4" id="addInfluencerDetailsCheckbox" onChange={(e) => {
                                    setSelectedInfluencer(null);
                                    setInfluencerList(null);
                                    setAgentInfluencerLinkStatus(null);
                                    setShowAddInfluencerDetails(e.target.checked)
                                }} />
                            </div>
                        </div>
                        {!showAddInfluencerDetails && <>
                            <div>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='Search Influencer Name / Mobile / Email' id='influencerSearch' onChange={_debounce((e) => setInfluencerSearchValue(e), 600)} />
                            </div>
                            <div className="max-h-80 overflow-y-auto mb-6">
                                {
                                    loadingState?.loadingInfluencer ?
                                        <div className='mt-2 flex justify-center w-full'> <Spinner /></div> : (influencerList?.data?.length > 0 &&
                                            influencerList?.data?.map((item) => (
                                                <div key={item?._id} className='cursor-pointer hover:bg-gray-200 px-3 py-2 rounded-md text-sm flex items-center flex-wrap gap-2' onClick={() => onInfluencerSelect(item)}>
                                                    <img src={item?.channelLogo} alt="" className='h-7' />
                                                    {item?.channelName}
                                                </div>
                                            )))
                                }
                                {
                                    influencerList?.responseCode == 500 && <p className='text-red-700 text-xs text-center mt-4'>
                                        {influencerList?.message} <br />
                                        Please try Create a new Influencer.
                                    </p>
                                }
                            </div>
                        </>}

                        {showAddInfluencerDetails && <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                            <div className="">
                                <label htmlFor="channelName" className='text-sm font-semibold mb-1'>Channel Name*</label>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='channelName' />
                            </div>
                            <div className="">
                                <label htmlFor="channelLink" className='text-sm font-semibold mb-1'>Channel Link*</label>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='channelLink' />
                            </div>
                        </div>}
                    </div>

                    {/* Agent */}
                    <div className="mb-10">
                        <div className='flex gap-2 justify-between items-center mb-2 flex-wrap'>
                            <label htmlFor="name" className='text-sm font-semibold mb-1'>Select Agent</label>
                            <div className='flex gap-2 items-center'>
                                <label htmlFor='addAgentDetailsCheckbox' className="text-sm font-semibold">Add New Agent Details</label>
                                <input type="checkbox" className="h-4 w-4" id="addAgentDetailsCheckbox" onChange={(e) => {
                                    setSelectedAgent(null);
                                    setAgentList(null);
                                    setAgentInfluencerLinkStatus(null);
                                    setShowAddAgentDetails(e.target.checked)
                                }} />
                            </div>
                        </div>

                        {!showAddAgentDetails && <>
                            <div>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='Search Agent Name / Mobile / Email' id='agentSearch' onChange={_debounce((e) => setAgentSearchValue(e), 600)} />
                            </div>
                            <div className="max-h-80 overflow-y-auto">
                                {
                                    loadingState?.loadingAgent ? <div className='mt-2 flex justify-center w-full'> <Spinner /></div> : (
                                        agentList?.data?.length > 0 &&
                                        agentList?.data?.map((item) => (
                                            <div key={item?._id} className='cursor-pointer hover:bg-gray-200 px-3 py-2 rounded-md text-sm flex items-center flex-wrap gap-2' onClick={() => onAgentSelect(item)}>
                                                <img src={item?.profilePic} alt="" className='h-7' />
                                                {item?.name} - {item?.phone} - {item?.email}
                                            </div>
                                        )))
                                }
                                {
                                    agentList?.responseCode == 500 && <p className='text-red-700 text-xs text-center mt-4'>
                                        {agentList?.message} <br />
                                        Please try Create a new agent.
                                    </p>
                                }
                            </div>
                        </>}

                        {showAddAgentDetails && <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                            <div className="">
                                <label htmlFor="agentName" className='text-sm font-semibold mb-1'>Agent Name*</label>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='agentName' />
                            </div>
                            <div className="">
                                <label htmlFor="agentMobile" className='text-sm font-semibold mb-1'>Agent's Mobile*</label>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' maxLength={10} id='agentMobile' />
                            </div>
                        </div>}
                    </div>

                    {agentInfluencerLinkStatus?.responseCode == 500 && <div className='flex gap-2 justify-center items-center'>
                        <label htmlFor='agentInfluencerLinkCheckbox' className="text-sm font-semibold text-yellow-600 italic text-center">*Selected Agent & Influencer are not linked together , to link them select this checkbox.</label>
                        <input type="checkbox" className="h-4 w-4" id="agentInfluencerLinkCheckbox" />
                    </div>}

                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' disabled={loadingState?.loadingAgent || loadingState?.loadingInfluencer || loadingState?.loadingDestinationUrlCheck} onClick={handleClose}>Cancel</button>
                        <button className={`${(loadingState?.loadingAgent || loadingState?.loadingInfluencer || loadingState?.loadingDestinationUrlCheck || destinationUrlCheck?.responseCode === 500) ? 'disabled-btn' : 'primary-btn'}`} disabled={loadingState?.loadingAgent || loadingState?.loadingInfluencer || loadingState?.loadingDestinationUrlCheck || destinationUrlCheck?.responseCode === 500} onClick={() => createPromotion()}>Create</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CreatePromotionModal